import { useCallback, useEffect, useRef } from "react";
import { PharmaStpFileModel } from "../../../data-model/nycbsPharmaOrder";
import { makePostCallForAsteraOncologyExternal } from "../apis/makePostCallForAsteraOncologyExternal";
import { AsteraOncologyExternalTableState } from "./useAsteraOncologyExternalTableData";
import { AsteraOncologyExternalFilterPayload } from "./useFilterPayload";

export const useFilterAndSearchEffect = (
  filterPayload: AsteraOncologyExternalFilterPayload | null,
  initialDataFetchingExecuted: boolean,
  setTableData: React.Dispatch<React.SetStateAction<PharmaStpFileModel[]>>,
  setAsteraOncologyExternalState: React.Dispatch<
    React.SetStateAction<AsteraOncologyExternalTableState>
  >,
  setPaginationResetCount: React.Dispatch<React.SetStateAction<number>>,
): void => {
  const initialDataFetchingExecutedRef = useRef(initialDataFetchingExecuted);
  const setTableDataRef = useRef(setTableData);
  const setAsteraOncologyExternalStateRef = useRef(
    setAsteraOncologyExternalState,
  );
  const setPaginationResetCountRef = useRef(setPaginationResetCount);

  useEffect(() => {
    initialDataFetchingExecutedRef.current = initialDataFetchingExecuted;
    setTableDataRef.current = setTableData;
    setAsteraOncologyExternalStateRef.current = setAsteraOncologyExternalState;
    setPaginationResetCountRef.current = setPaginationResetCount;
  }, [
    initialDataFetchingExecuted,
    setTableData,
    setAsteraOncologyExternalState,
    setPaginationResetCount,
  ]);

  const fetchData = useCallback(() => {
    if (filterPayload) {
      makePostCallForAsteraOncologyExternal(
        filterPayload,
        setAsteraOncologyExternalStateRef.current,
        setTableDataRef.current,
        setPaginationResetCountRef.current,
      );
    }
  }, [filterPayload]);

  useEffect(() => {
    if (filterPayload && initialDataFetchingExecutedRef.current) {
      fetchData();
    }
  }, [filterPayload, fetchData]);
};
